import { CalendarBlank, Smiley } from 'phosphor-react'

const InformationComplementary = ({ languages, delta_joined, number_of_consultations }) => {
  return (
    <div className='container-info-complementary'>
      {languages.length !== 0 && (
        <div
          className='row'
          style={{
            marginBottom: '0'
          }}
        >
          <div className='col-12'>
            <p>
              <span id='psycho-languages'>{'Atendimento também em '}</span>
              {languages.map((language, index) =>
                index != languages.length - 1 ? `${language} / ` : `${language}`
              )}
            </p>
          </div>
        </div>
      )}
      {number_of_consultations > 10 && (
        <div className='row'>
          <div className={number_of_consultations > 0 ? 'col-12 col-md-6' : 'col-12 col-md-12'}>
            <p>
              <div
                className='row'
                style={{
                  marginLeft: '0',
                  marginRight: '0'
                }}
              >
                <div
                  className='col-12 col-md-12'
                  style={{
                    paddingLeft: '0',
                    paddingRight: '0',
                    maxWidth: '100%'
                  }}
                >
                  {delta_joined.years !== 0 ? (
                    <span>
                      <CalendarBlank
                        size={18}
                        style={{
                          marginRight: '5px'
                        }}
                      />
                      {delta_joined.years === 1
                        ? `${delta_joined.years} ano`
                        : `${delta_joined.years} anos`}
                      {delta_joined.months > 0 &&
                        (delta_joined.months > 1
                          ? `, ${delta_joined.months} meses `
                          : `, ${delta_joined.months} mês `)}
                    </span>
                  ) : (
                    <span>
                      <CalendarBlank
                        size={18}
                        style={{
                          marginRight: '5px'
                        }}
                      />
                      {delta_joined.months <= 1 ? 'Novo ' : `${delta_joined.months} meses `}
                    </span>
                  )}
                </div>
                <div
                  className='col-12 col-md-12'
                  style={{
                    paddingLeft: '0',
                    paddingRight: '0'
                  }}
                >
                  na Vittude
                </div>
              </div>
            </p>
          </div>
          <div className={'col-12 col-md-6'}>
            <p>
              <div
                className='row'
                style={{
                  marginLeft: '0',
                  marginRight: '0'
                }}
              >
                <div
                  className='col-12 col-md-12'
                  style={{
                    paddingLeft: '0',
                    paddingRight: '0',
                    maxWidth: '100%'
                  }}
                >
                  <span>
                    <Smiley
                      size={18}
                      style={{
                        marginRight: '5px'
                      }}
                    />
                    {number_of_consultations > 1
                      ? `${number_of_consultations} consultas `
                      : `${number_of_consultations} consulta `}
                  </span>
                </div>
                <div
                  className='col-12 col-md-12'
                  style={{
                    paddingLeft: '0',
                    paddingRight: '0'
                  }}
                >
                  {number_of_consultations > 1 ? 'realizadas' : 'realizada'}
                </div>
              </div>
            </p>
          </div>
        </div>
      )}
    </div>
  )
}

export default InformationComplementary
